import { ExtendCSS } from 'vcc-ui';

export const imageWrapperStyle: ExtendCSS = ({ theme: { baselineGrid } }) => ({
  width: '100%',
  marginBottom: 0,
  marginTop: baselineGrid * 3,
  '& + picture': {
    marginTop: baselineGrid * 4,
    fromM: {
      marginTop: baselineGrid * 5,
    },
  },
  fromM: {
    marginTop: baselineGrid * 4,
  },
});
